import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { Icon } from '../index'
import { util } from '../../../util'

const Indicator = ({ size, margin, className, color, icon, label, hover }) => {
    return (
        <div className={util.joinClasses('indicator', className, hover)}>
            <Icon className={'mt-1'} size={size} margin={margin} color={color} renderIcon={icon} />
            <p className={util.joinClasses('indicator__label', size)}>{label}</p>
        </div>
    )
}

Indicator.propTypes = {
    size: PropTypes.oneOf(['xxxs', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
    margin: PropTypes.string,
    className: PropTypes.string,
    color: PropTypes.oneOf(['disable', 'danger', 'color-check', 'success', 'warning', 'info']),
    img: PropTypes.func,
    label: PropTypes.string,
    hover: PropTypes.oneOf(['pointer']),
}

export default memo(Indicator)
